export default __webpack_public_path__ + "static/media/nftLeft.561eca57.png";